import { render, staticRenderFns } from "./TesztModal.vue?vue&type=template&id=e398ad8e&"
import script from "./TesztModal.vue?vue&type=script&lang=js&"
export * from "./TesztModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports